import React from 'react'
import { Segment } from 'semantic-ui-react'

import { InvoiceOperationLogTypeEnum } from '../../services/utils/DTOEnums'

const WaivingInvoice = ({ invoice }) => {
  return (
    <>
      <Segment>
        {invoice?.operationLogs?.map(
          (item) =>
            item &&
            item.logType === InvoiceOperationLogTypeEnum.WAIVED && (
              <div key={item.ref}>{item.comment}</div>
            )
        )}
      </Segment>
    </>
  )
}

export default WaivingInvoice
